/* Line Lion — swipeable rail
   Progressive enhancement for [data-ll-rail]. Touch swipe works without JS;
   this only wires the prev/next buttons and their disabled states. */
(function () {
  function initRail(root) {
    var rail = root.querySelector('[data-ll-rail-track]');
    var prev = root.querySelector('[data-ll-rail-prev]');
    var next = root.querySelector('[data-ll-rail-next]');
    if (!rail) return;

    function step() {
      var first = rail.firstElementChild;
      if (!first) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function sync() {
      if (!prev || !next) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { rail.scrollLeft -= step(); });
    if (next) next.addEventListener('click', function () { rail.scrollLeft += step(); });

    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    // Pause any other playing video when one starts, so audio never overlaps.
    rail.querySelectorAll('video').forEach(function (v) {
      v.addEventListener('play', function () {
        rail.querySelectorAll('video').forEach(function (other) {
          if (other !== v) other.pause();
        });
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ll-rail]').forEach(initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
